
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entries",
      function () {
        return require("private-next-pages/entries.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/entries"])
      });
    }
  